<p-toast key="tst_login"></p-toast>

<!-- Container principal da tela de login -->
<div class="login-container">

  <!-- Imagem de fundo da página -->
  <img src="assets/images/login/highway.jpg"
       alt="Background"
       class="background-image">

  <!-- Container do formulário de login -->
  <div class="login-form-container">

    <!-- Logo principal do login -->
    <img [src]="module.logoImgPath"
         *ngIf="!!module && false"
         [alt]="module.name + ' logo'"
         class="login-logo">

    <div class="w-full text-center label-line">
      <span style="background-color: rgb(236 234 244);" class="text-base font-semibold">Acesse Sua Conta</span>
    </div>

    <!-- Campo de input para o email -->
    <p-floatlabel variant="on" class="w-full">
        <input pInputText
                 id="email"
                 [disabled]="isLoading"
                 [(ngModel)]="model.email"
                 [ngStyle]="{'width': '100%'}"
                 (keydown.enter)="senhaInput.focus()"/>
        <label htmlFor="email">Email</label>
    </p-floatlabel>

    <!-- Campo de input para a senha -->
    <p-floatlabel variant="on" class="mt-4 w-full">
        <input pInputText
                 id="senha"
                 #senhaInput
                 [disabled]="isLoading"
                 type="password"
                 [(ngModel)]="model.password"
                 [ngStyle]="{'width': '100%'}"
                 (keydown.enter)="login()"/>
        <label htmlFor="senha">Senha</label>
    </p-floatlabel>

    <!-- Botão para enviar o formulário de login -->
    <div class="flex justify-content-center mt-4">
      <p-button [label]="isLoading ? loader.msgLoader ?? 'Entrando' : 'Entrar'"
                (onClick)="login()"
                icon="pi {{isLoading ? 'pi-spin pi-spinner' : 'pi-check'}}"
                size="large"
                [ngClass]="{
                  'opacity-50': isLoading,
                }"
                [style]="{'background-color': '#043681'}">
      </p-button>
    </div>

<!--     <p-button label="Esqueci a senha" [style]="{'color': '#043681'}"
              [link]="true" (click)="show()"
              [ngClass]="{
                'opacity-50': isLoading,
              }"
              styleClass="text-x"></p-button> -->
  </div>
  <img src="assets/images/login/logo-velsis.png"
       alt="Velsis logo" style="margin-bottom: 1rem;"
       class="absolute velsis-logo w-1 bottom-0">
</div>
